import React from "react";
import { Button, RadioGroup, Card, CardContent, Divider, Fab, FormControl, FormControlLabel, MenuItem, Pagination, Radio, Stack, Switch, TextField, Grow, Grid } from "@material-ui/core";
import {
  Typography,
  Box,
} from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { goToDoctor, goToLogin, goToUsers } from "../../../routes/Coordinator";
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import InputMask from 'react-input-mask';
import axios from "axios";
import { useEffect } from "react";


const syndicateName = [
  {
    value: "crm",
    label: "CRM",
  },
  {
    value: "cro",
    label: "CRO",
  },
  {
    value: "oab",
    label: "OAB",
  },
  {
    value: "crmv",
    label: "CRMV",
  },
];

function UseQuery() {
  return new URLSearchParams(window.location.search)
}

const DoctorRecord = () => {

  const [name, setName] = useState("")
  const [cpf_cnpj, setCpf_cnpj] = useState("")
  const [group_id, setGroupId] = useState("")
  const [syndicate_name, setSyndicate_name] = useState("")
  const [phone, setPhone] = useState("")
  const [syndicate_number, setSyndicate_number] = useState("")
  const [margin, setMargin] = useState("")
  const [signature, setSignature] = useState(null)
  const [zip, setZip] = useState("")
  const [street, setStreet] = useState("")
  const [neighborhood, setNeighborhood] = useState("")
  const [city, setCity] = useState("")
  const [state, setState] = useState("")
  const [number, setNumber] = useState("")
  const [complement, setComplement] = useState("")
  const [checkedcpf, setCheckedcpf] = useState(true);
  const [checkedcnpj, setCheckedcnpj] = useState(false);
  const navigate = useNavigate();


  const save = () => {
    let id = UseQuery().get("id")

    if (!id) {
      newDoctor()
    } else {
      EditDoctor()
    }
  }

  const newDoctor = () => {

    console.log(signature)
    let newMargin = margin.replace(/\./g, "")
    newMargin = newMargin.replace(",", ".")
    const formData = new FormData()
    formData.append("doctor[name]", name)
    formData.append("doctor[cpf_cnpj]", cpf_cnpj)
    formData.append("doctor[syndicate_name]", syndicate_name)
    formData.append("doctor[syndicate_number]", syndicate_number)
    formData.append("doctor[phone]", phone)
    formData.append("doctor[margin]", newMargin)
    formData.append("doctor[signature]", signature)
    formData.append("doctor[zip]", zip)
    formData.append("doctor[street]", street)
    formData.append("doctor[neighborhood]", neighborhood)
    formData.append("doctor[city]", city)
    formData.append("doctor[state]", state)
    formData.append("doctor[number]", number)
    formData.append("doctor[complement]", complement)
    axios.post(`${process.env.REACT_APP_BASE_URL}/doctors`, formData,
      {
        headers: {
          "access-token": localStorage.getItem("access-token"),
          "client": localStorage.getItem("client"),
          "token-type": localStorage.getItem("token-type"),
          "expiry": localStorage.getItem("expiry"),
          "uid": localStorage.getItem("uid")

        }
      })
      .then((response) => {
        alert("Médico cadastrado com sucesso!")
        goToDoctor(navigate)
      })
      .catch((erro) => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      }
      )

  }
  const EditDoctor = () => {
    let newMargin = margin.replace(/\./g, "")
    newMargin = newMargin.replace(",", ".")
    const formData = new FormData()
    formData.append("doctor[name]", name)
    formData.append("doctor[cpf_cnpj]", cpf_cnpj)
    formData.append("doctor[syndicate_name]", syndicate_name)
    formData.append("doctor[syndicate_number]", syndicate_number)
    formData.append("doctor[phone]", phone)
    formData.append("doctor[margin]", newMargin)
    if (signature) { formData.append("doctor[signature]", signature) }
    formData.append("doctor[zip]", zip)
    formData.append("doctor[street]", street)
    formData.append("doctor[neighborhood]", neighborhood)
    formData.append("doctor[city]", city)
    formData.append("doctor[state]", state)
    formData.append("doctor[number]", number)
    formData.append("doctor[complement]", complement)
    let id = UseQuery().get("id")
    let url = `${process.env.REACT_APP_BASE_URL}/doctors/${id}`
    axios.put(url, formData,
      {
        headers: {
          "access-token": localStorage.getItem("access-token"),
          "client": localStorage.getItem("client"),
          "expiry": localStorage.getItem("expiry"),
          "token-type": localStorage.getItem("token-type"),
          "uid": localStorage.getItem("uid")
        }
      })
      .then(response => {
        goToDoctor(navigate)
      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })
  }

  const Show = () => {
    let id = UseQuery().get("id")
    if (id) {
      let url = `${process.env.REACT_APP_BASE_URL}/doctors/${id}`

      axios.get(url,
        {
          headers: {
            "access-token": localStorage.getItem("access-token"),
            "client": localStorage.getItem("client"),
            "expiry": localStorage.getItem("expiry"),
            "token-type": localStorage.getItem("token-type"),
            "uid": localStorage.getItem("uid"),
            "Content-Type": "application/json"
          }
        })
        .then(response => {
          setName(response.data.name)
          setCpf_cnpj(response.data.cpf_cnpj)
          setSyndicate_name(response.data.syndicate_name.toLowerCase())
          setPhone(response.data.phone)
          setSyndicate_number(response.data.syndicate_number)
          setMargin(response.data.margin.toLocaleString("pt-br", { minimumFractionDigits: 2 }))
          setZip(response.data.zip)
          setStreet(response.data.street)
          setNeighborhood(response.data.neighborhood)
          setCity(response.data.city)
          setState(response.data.state)
          setNumber(response.data.number)
          setComplement(response.data.complement)
        })
        .catch(erro => {
          Object.keys(erro.response.data).forEach((item) => {
            alert(erro.response.data[item]);
          });
          if (erro.response.status === 401) {
            goToLogin(navigate)
          }
        })
    }
  }
  const getAddress = () => {

    axios.get(`https://viacep.com.br/ws/${zip}/json/`)
      .then(response => {
        setStreet(response.data.logradouro)
        setNeighborhood(response.data.bairro)
        setCity(response.data.localidade)
        setState(response.data.uf)
      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })

  }
  const formatCurrency = (value) => {
    let newvalue = value.replace(",", "")
    newvalue = newvalue.replace(/\./g, "")
    let tam = newvalue.length;
    if ((tam > 2) && (tam <= 5)) newvalue = newvalue.substr(0, tam - 2) + "," + newvalue.substr(tam - 2, tam);
    if ((tam >= 6) && (tam <= 8)) newvalue = newvalue.substr(0, tam - 5) + "." + newvalue.substr(tam - 5, 3) + "," + newvalue.substr(tam - 2, tam);
    if ((tam >= 9) && (tam <= 11)) newvalue = newvalue.substr(0, tam - 8) + "." + newvalue.substr(tam - 8, 3) + "." + newvalue.substr(tam - 5, 3) + "," + newvalue.substr(tam - 2, tam);
    if ((tam >= 12) && (tam <= 14)) newvalue = newvalue.substr(0, tam - 11) + "." + newvalue.substr(tam - 11, 3) + "." + newvalue.substr(tam - 8, 3) + "." + newvalue.substr(tam - 5, 3) + "," + newvalue.substr(tam - 2, tam);
    if ((tam >= 15) && (tam <= 17)) newvalue = newvalue.substr(0, tam - 14) + "." + newvalue.substr(tam - 14, 3) + "." + newvalue.substr(tam - 11, 3) + "." + newvalue.substr(tam - 8, 3) + "." + newvalue.substr(tam - 5, 3) + "," + newvalue.substr(tam - 2, tam);
    setMargin(newvalue)
  }
  useEffect(() => {
    Show()

  }, [])
  const iconCPF = (
      <Grid item xs={12} md={12} lg={4} sx={{display: checkedcpf ? 'block' : 'none'}}>
        <InputMask
          required
          id="outlined-required"
          onChange={(e) => setCpf_cnpj(e.target.value)}
          value={cpf_cnpj}
          name={"cpf_cnpj"}
          type={"text"}
          mask="999.999.999-99"
          disabled={false}
          variant={"outlined"}
          fullWidth

        >
          {() => <TextField fullWidth label={"CPF"} />}
        </InputMask>
      </Grid>
  );
  const iconCNPJ = (
      <Grid item xs={12} md={12} lg={4} sx={{display: checkedcnpj ? 'block' : 'none'}}>
        <InputMask
          required
          id="outlined-required"
          onChange={(e) => setCpf_cnpj(e.target.value)}
          value={cpf_cnpj}
          name={"cpf_cnpj"}
          type={"text"}
          mask="99.999.999/9999-99"
          disabled={false}
          variant={"outlined"}
          fullWidth
          

        >
          {() => <TextField fullWidth label={"CNPJ"} />}
        </InputMask>
      </Grid>
  );
  const handleChangeCheckedCPF = (value) => {
    setCheckedcpf(value);
    setCheckedcnpj(!value);
  };
  const handleChangeCheckedCNPJ = (value) => {
    setCheckedcnpj(value);
    setCheckedcpf(!value);
  };
  return (
    <Box>
      <Card variant="outlined">
        <CardContent>
          <Typography variant="h3" sx={{ mb: 2 }}>Cadastrar Médico</Typography>
          <Divider />
          <form>
            <Typography sx={{ paddingTop: 1 }} variant="h3">Dados</Typography>
            <CardContent
              sx={{
                padding: "30px",
              }}
            >
              <Grid container rowSpacing={2} columnSpacing={3}>
                <Grid item xs={12} md={12} lg={6}>
                  <TextField
                    fullWidth
                    required
                    id="outlined-required"
                    label="Nome"
                    onChange={(e) => setName(e.target.value)}
                    value={name}
                    name={"name"}
                    type={"name"}
                  />
                </Grid>
                <Grid item xs={12} md={12} lg={2} sx={{marginTop: 2}}>
                <FormControlLabel
                    control={<Switch size="small" checked={checkedcpf} onChange={(e) => handleChangeCheckedCPF(e.target.checked)} />}
                    label="CPF"
                  />
                  <FormControlLabel
                    control={<Switch size="small" checked={checkedcnpj} onChange={(e) => handleChangeCheckedCNPJ(e.target.checked)} />}
                    label="CNPJ"
                  />
                </Grid>
                  {iconCPF}
                  {iconCNPJ}
                <Grid item xs={12} md={12} lg={3}>
                  <TextField
                    fullWidth
                    select
                    label="Conselho"
                    required
                    id="function"
                    onChange={(e) => setSyndicate_name(e.target.value)}
                    value={syndicate_name}
                    name={"syndicate_name"}
                    type={"syndicate_name"}
                  >
                    {syndicateName.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} md={12} lg={3}>
                  <TextField
                    fullWidth
                    required
                    id="outlined-required"
                    label="Número"
                    onChange={(e) => setSyndicate_number(e.target.value)}
                    value={syndicate_number}
                    name={"syndicate_number"}
                    type={"syndicate_number"}
                  />
                </Grid>
                <Grid item xs={12} md={12} lg={6}>
                  <InputMask
                    required
                    id="outlined-required"
                    onChange={(e) => setPhone(e.target.value)}
                    value={phone}
                    name={"phone"}
                    type={"text"}
                    mask="(99) 99999-9999"
                    disabled={false}

                  >
                    {() => <TextField fullWidth label={"Telefone"} />}
                  </InputMask>
                </Grid>
              </Grid>
            </CardContent>
            <Typography variant="h3">Endereço</Typography>
            <CardContent
              sx={{
                padding: "30px",
              }}
            >
              <Grid container rowSpacing={2} columnSpacing={3}>
                <Grid item xs={12} md={12} lg={6}>
                  <TextField
                    fullWidth
                    id="outlined-required"
                    label="CEP"
                    onChange={(e) => setZip(e.target.value)}
                    value={zip}
                    name={"zip"}
                    type={"zip"}
                    onBlur={() => getAddress()}
                  />
                </Grid>
                <Grid item xs={12} md={12} lg={6}>
                  <TextField
                    fullWidth
                    required
                    id="outlined-required"
                    label="Logradouro"
                    onChange={(e) => setStreet(e.target.value)}
                    value={street}
                    name={"street"}
                    type={"street"}
                  />
                </Grid>
                <Grid item xs={12} md={12} lg={6}>
                  <TextField
                    fullWidth
                    required
                    id="outlined-required"
                    label="Bairro"
                    onChange={(e) => setNeighborhood(e.target.value)}
                    value={neighborhood}
                    name={"neighborhood"}
                    type={"neighborhood"}
                  />
                </Grid>
                <Grid item xs={12} md={12} lg={6}>
                  <TextField
                    fullWidth
                    required
                    id="outlined-required"
                    label="Cidade"
                    onChange={(e) => setCity(e.target.value)}
                    value={city}
                    name={"city"}
                    type={"city"}
                  />
                </Grid>
                <Grid item xs={12} md={12} lg={6}>
                  <TextField
                    fullWidth
                    required
                    id="outlined-required"
                    label="Estado"
                    onChange={(e) => setState(e.target.value)}
                    value={state}
                    name={"state"}
                    type={"state"}
                  />
                </Grid>
                <Grid item xs={12} md={12} lg={6}>
                  <TextField
                    fullWidth
                    required
                    id="outlined-required"
                    label="Número"
                    onChange={(e) => setNumber(e.target.value)}
                    value={number}
                    name={"number"}
                    type={"number"}
                  />
                </Grid>
                <Grid item xs={12} md={12} lg={6}>
                  <TextField
                    fullWidth
                    id="outlined-required"
                    label="Complemento"
                    onChange={(e) => setComplement(e.target.value)}
                    value={complement}
                    name={"complement"}
                    type={"complement"}
                  />
                </Grid>
              </Grid>
            </CardContent>
            <Typography variant="h3">Margem Mensal</Typography>
            <CardContent
              sx={{
                padding: "30px",
              }}
            >
              <Grid container columnSpacing={3}>
                <Grid item xs={12} md={12} lg={6}>
                  <TextField
                    fullWidth
                    required
                    id="outlined-required"
                    label="Margem Mensal"
                    value={margin}
                    name={"margin"}
                    type={"text"}
                    onChange={(e) => formatCurrency(e.target.value)}
                  />
                </Grid>
              </Grid>
            </CardContent>
            <Typography variant="h3">Assinatura digitalizada</Typography>
            <CardContent
              sx={{
                padding: "30px",
              }}
            >
              <Grid container columnSpacing={3}>
                <Grid item xs={12} md={12} lg={6}>
                  <TextField
                    type="file"
                    onChange={(e) => { setSignature(e.target.files[0]) }}
                    fullWidth
                  />
                </Grid>
              </Grid>
            </CardContent>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end"
              }}
            >
              <Box>
                <Button onClick={save} variant="contained" color="success" startIcon={<AddIcon />}>
                  Salvar
                </Button>
                <Button onClick={() => goToDoctor(navigate)} variant="outlined" startIcon={<ArrowBackIosIcon />}>
                  Voltar
                </Button>
              </Box>
            </Box>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
};

export default DoctorRecord;